namespace $ {
	/** User history commands must outlive the keyboard event that started them. */
	export class $shm_hitalama_map_history_command {
		private static queues = new WeakMap<$shm_hitalama_map,Promise<unknown>>

		static enqueue( map: $shm_hitalama_map, direction: 'undo' | 'redo' ) {
			const previous=this.queues.get(map) ?? Promise.resolve()
			const command=previous.catch(()=>undefined).then(()=>{
				const api=$mol_wire_async(map)
				return direction==='undo' ? api.history_undo() : api.history_redo()
			})
			const tracked=command.finally(()=>{if(this.queues.get(map)===tracked) this.queues.delete(map)})
			this.queues.set(map,tracked)
			return tracked
		}
	}
}
